function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "fill",
  transform: "translate(-8.243 -35.975)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m106.322 167.145a3.8 3.8 0 0 0 -.9-.107 3.753 3.753 0 0 0 -2.739 1.172.7.7 0 0 0 1.01.965 2.369 2.369 0 0 1 1.728-.74 2.4 2.4 0 0 1 .567.068.7.7 0 1 0 .33-1.357z",
  transform: "translate(-88.266 -123.087)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m66.318 105.642a.7.7 0 0 0 1.051-.92 7.914 7.914 0 0 0 -11.68-.257.7.7 0 0 0 1.01.965 6.517 6.517 0 0 1 9.619.212z",
  transform: "translate(-44.253 -62.048)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.058 39.873a12.144 12.144 0 0 0 -8.9-3.9 12.007 12.007 0 0 0 -8.72 3.708.7.7 0 0 0 1.006.969 10.622 10.622 0 0 1 7.714-3.281 10.744 10.744 0 0 1 7.873 3.449.7.7 0 0 0 1.027-.947z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m192.687 180.672a.7.7 0 0 0 -.988 0l-1.473 1.473-1.473-1.473a.7.7 0 0 0 -.988.988l1.473 1.473-1.473 1.473a.7.7 0 0 0 .988.988l1.473-1.473 1.473 1.473a.7.7 0 1 0 .988-.988l-1.473-1.473 1.473-1.473a.7.7 0 0 0 0-.988z",
  transform: "translate(-167.934 -135.822)"
}));

function SvgIconOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 18 14",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffline);
export default __webpack_public_path__ + "static/media/icon_offline.d7298d51.svg";
export { ForwardRef as ReactComponent };